export default "__VITE_ASSET__7404a6a3__"